import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";
import { Howl } from "howler";
import axios from "axios";

const OrderContext = createContext<number | undefined>(undefined);

interface OrderProviderProps {
  children: ReactNode;
}

export const useOrderContext = () => {
  const context = useContext(OrderContext);

  return context;
};

export const OrderProvider: React.FC<OrderProviderProps> = ({ children }) => {
  const [orders, setOrders] = useState<number>(0);
  const pollOrders = async () => {
    try {
      const response = await axios.get(
        "/documents?page=1&pageSize=1&type=DISPATCH&status=OPEN"
      );
      const newOrders = response?.data?.total;

      if (orders !== newOrders) {
        if (orders && newOrders > orders) {
          playSound();
        }
        setOrders(newOrders);
      }
    } catch (error) {
      console.error("Errore nel recupero degli ordini:", error);
    }
  };

  const playSound = () => {
    const sound = new Howl({
      src: ["/assets/bell.mp3"],
      volume: 1,
    });
    sound.play();
  };

  useEffect(() => {
    const pollInterval = setInterval(pollOrders, 10000);

    return () => {
      clearInterval(pollInterval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orders]);

  return (
    <OrderContext.Provider value={orders}>{children}</OrderContext.Provider>
  );
};
